import { useAppDispatch, useAppSelector } from 'hooks';
import { Action } from 'redux';
import { settingsSelector } from 'store/slices/mapV2/mapReducer/selectors';
import { settingsActions } from 'store/slices/mapV2/mapReducer/settingsSlice';
import { initialState as mapSettingsInitialState } from 'store/slices/mapV2/mapReducer/settingsSlice/constants';

import { Header } from 'components/Header/Header';
import { Geocoder } from 'components/Map/Geocoder/Geocoder';
import { MapToolsControl } from 'components/Map/MapToolsControl';
import { ObjectCounters } from 'components/Map/ObjectCounters';
import { useMapSettingsLocalStorage } from 'utils/localStorage';

export const MapHeader = () => {
  const {
    showAim,
    showCustomCursors,
    showObjects,
    showLabels,
    clusterObjects,
  } = useAppSelector(settingsSelector);

  const [, updateMapLocalSettings] = useMapSettingsLocalStorage(
    mapSettingsInitialState
  );

  const dispatch = useAppDispatch();

  const handleToggleMenuItem =
    (item: string, value: boolean, action: (value: boolean) => Action) =>
    () => {
      dispatch(action(!value));
      updateMapLocalSettings(item, !value);
    };

  const burgerMenuItems = [
    {
      title: `${showAim ? 'Выключить' : 'Включить'} прицел`,
      onClick: handleToggleMenuItem(
        'showAim',
        showAim,
        settingsActions.setShowAim
      ),
    },
    {
      title: `${
        showCustomCursors ? 'Отключить' : 'Включить'
      } кастомные курсоры`,
      onClick: handleToggleMenuItem(
        'showCustomCursors',
        showCustomCursors,
        settingsActions.setShowCursors
      ),
    },
    {
      title: showLabels
        ? 'Скрыть названия с карты'
        : 'Отобразить названия на карте',
      onClick: handleToggleMenuItem(
        'showLabels',
        showLabels,
        settingsActions.setShowLabels
      ),
    },
    {
      title: showObjects
        ? 'Скрыть объекты на карте'
        : 'Показать объекты на карте',
      onClick: handleToggleMenuItem(
        'showLayers',
        showObjects,
        settingsActions.setShowObjects
      ),
    },
    {
      title: clusterObjects
        ? 'Разгруппировать объекты'
        : 'Группировать объекты',
      onClick: handleToggleMenuItem(
        'clusterObjects',
        clusterObjects,
        settingsActions.setClusterObjects
      ),
    },
  ];

  return (
    <Header burgerMenuItems={burgerMenuItems} className="w-full">
      <div className="flex justify-between items-center w-full ml-6">
        <div className="grid grid-cols-[minmax(0,410px)_auto_auto] items-center gap-4 w-full">
          <Geocoder
            placeholder="Поиск по координате, локациям, квадрату"
            size="s"
            theme="dark"
            classNames={{ container: 'z-10' }}
          />
          <ObjectCounters />
        </div>
        <MapToolsControl />
      </div>
    </Header>
  );
};
